import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { NodeAction } from '../node.action';

type IDependencies = IClientApiDependencySegment;

export const removeNodeEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(NodeAction.remove.started),
  mergeMap((params) => {
    const { nodeId } = params;

    return dependencies.api.deleteNode({ nodeId }).pipe(
      mergeMap(() => {
        return [
          NodeAction.remove.done({ params, result: { nodeId } }),
        ];
      }),
      catchApiError((error) => {
        return [
          NodeAction.remove.failed({ params, error: undefined }),
          createApiErrorNotification(error),
        ];
      }),
    );
  }),
);
